import '../../../tc-vue-mixins/src/form-mixins.scss.js';
import '../../../tc-vue-mixins/src/edit-mode.js';
import formField from '../../../tc-vue-mixins/src/form-field.js';
import isEqual from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/lodash.isequal/4.5.0/node_modules/lodash.isequal/index.js';
import '../../../tc-vue-mixins/src/input-values.js';
import validatable from '../../../tc-vue-mixins/src/validatable.js';
import '../../../tc-vue-mixins/src/overlays.js';

//

var script = {
  name: 'TcFieldset',
  mixins: [formField, validatable],
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'input'
  },
  provide: function provide() {
    return {
      group: this,
      inline: this.inline
    }
  },
  props: {
    caption: {
      type: String,
      required: true,
      default: 'Add caption for accessibility'
    },
    name: {
      type: String,
      required: false
    },
    options: {
      type: Array
    },
    checked: {
      type: [String, Object, Number, Boolean, Array],
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    childComponents: {
      type: String,
      validator: function (type) { return type === 'radio' || type === 'checkbox'; }
    },
    parentClass: {
      type: String
    }
  },
  data: function data() {
    return {
      selectedValue: this.checkInputType()
    }
  },
  computed: {
    emptyCaption: function emptyCaption() {
      if (this.caption !== 'Add caption for accessibility')
        { return 'tc-fieldset--caption-hidden' }
      return 'tc-fieldset--caption'
    }
  },
  methods: {
    checkInputType: function checkInputType() {
      if (this.childComponents === 'radio') { return this.checked }
      if (this.childComponents === 'checkbox') { return this.checked || [] }
    }
  },
  watch: {
    checked: function checked(newValue) {
      this.checkedValue = newValue;
    },
    selectedValue: function selectedValue(newValue) {
      if (!isEqual(newValue, this.checked)) {
        this.$emit('input', newValue);
      }
    }
  }
};

export default script;
